import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const comboboxmulti = ({ id, col, attributes, value, label, datos, onChange, placeholder }) => {

    const stilo = { display: !!attributes.hidden ? attributes.hidden : 'unset' };

    return (
        <div className={`col-sm-${col} col-md-${col}`} style={stilo}>
            <div className="form-group">
                <label htmlFor={id}>{label}</label>
                <Select id={id}
                    name={id}
                    placeholder={placeholder ?? ""}
                    value={value}
                    onChange={onChange}
                    options={datos}
                    isMulti
                    components={makeAnimated()}
                    isDisabled={attributes.readOnly}
                >
                </Select>
            </div>
        </div>
    );
}

export default comboboxmulti;